/**
 * P5 admin CRA — convention for async data in useEffect:
 * 1) const ac = new AbortController()
 * 2) Pass { signal: ac.signal } to axios/http calls in that effect
 * 3) return () => ac.abort() from the effect (unmount + dependency change)
 * 4) In .catch, skip UI updates when isAbortError(err)
 */
export function isAbortError(err) {
  if (err == null) return false;
  if (err.code === "ERR_CANCELED") return true;
  if (err.name === "CanceledError") return true;
  if (err.name === "AbortError") return true;
  if (String(err.message || "").toLowerCase().includes("cancel")) return true;
  return false;
}
